import type { ApiKeyCreada, ApiKeyCrearInput, ApiKeyPublic } from '@app/shared';

import { api } from '../../../lib/api';

export const apiKeysApi = {
  async list(): Promise<{ apiKeys: ApiKeyPublic[] }> {
    const { data } = await api.get<{ apiKeys: ApiKeyPublic[] }>('/admin/api-keys');
    return data;
  },
  async crear(input: ApiKeyCrearInput): Promise<ApiKeyCreada> {
    const { data } = await api.post<ApiKeyCreada>('/admin/api-keys', input);
    return data;
  },
  async revocar(id: string): Promise<void> {
    await api.delete(`/admin/api-keys/${id}`);
  },
};
